import { languages } from "@shared/data";
import { Combobox, Option } from "@fluentui/react-components";

export default function LanguageComboBox({ value, onOptionSelect }) {
  // Find the name that corresponds to the selected ID
  const selectedLanguage = languages.find((l) => l.code === value);
  const selectedName = selectedLanguage?.name ?? "";

  const handleSelect = (e, data) => {
    //console.log(`e: ${e} (${typeof e}) - data: ${data} (${typeof data})`);
    if (!data) return;
    const selected = data.optionValue;
    const matched = languages.find((l) => l.name === selected);
    //console.log(`New language ${data.optionValue}`);
    onOptionSelect?.(matched?.code ?? null); // pass back the ID
  };

  return (
    <Combobox value={selectedName} onOptionSelect={handleSelect}>
      {languages.map((l) => (
        <Option key={l.code} value={l.name}>
          {l.name}
        </Option>
      ))}
    </Combobox>
  );
}
